import { Api } from 'models/services/api';
import { CreateOriginalMenuCategoryQuery } from 'models/services/graphql';

import { OriginalMenuCategoryData, OriginalMenuCategoryDataToSave } from '../index';

type DataToCreate = {
  input: OriginalMenuCategoryDataToSave;
};

const RequestQuery = `
  mutation CreateOriginalMenuCategory($input: OriginalMenuCategoryInput!) {
    ${CreateOriginalMenuCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createOriginalMenuCategory: OriginalMenuCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalMenuCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createOriginalMenuCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };